import { Instagram, Mail, Phone } from "lucide-react";
import { CONTACT_EMAIL, PHONE, PHONE_TEL } from "@/lib/data";

export const Footer = () => (
  <footer className="bg-[#0A0A0A] text-white pt-20 pb-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="font-display text-7xl md:text-9xl uppercase leading-[0.85]">
        L'Atelier <br />
        <span className="text-[#FFD1DC]">Loraine B</span>
      </h2>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <p className="font-sans text-xs font-bold tracking-widest uppercase text-white/50 mb-4">
            Adresse
          </p>
          <p className="font-sans text-base">
            Saint-Jean-de-Luz <br />
            Pays Basque · France
          </p>
        </div>
        <div>
          <p className="font-sans text-xs font-bold tracking-widest uppercase text-white/50 mb-4">
            Contact
          </p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 hover:text-[#FFF3B0] transition-colors">
            <Mail size={16} /> <span className="break-all text-sm">{CONTACT_EMAIL}</span>
          </a>
          <a href={`tel:${PHONE_TEL}`} className="mt-2 flex items-center gap-2 hover:text-[#FFF3B0] transition-colors">
            <Phone size={16} /> {PHONE}
          </a>
        </div>
        <div>
          <p className="font-sans text-xs font-bold tracking-widest uppercase text-white/50 mb-4">
            Réseaux
          </p>
          <div className="flex flex-col gap-2">
            <a
              href="https://instagram.com/atelierloraineb"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-1"
              className="flex items-center gap-2 hover:text-[#FFD1DC] transition-colors"
            >
              <Instagram size={16} /> @atelierloraineb
            </a>
            <a
              href="https://instagram.com/low.rainboww"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-2"
              className="flex items-center gap-2 hover:text-[#FFD1DC] transition-colors"
            >
              <Instagram size={16} /> @low.rainboww
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 border-t border-white/15 pt-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50 font-sans">
        <p>
          © {new Date().getFullYear()} L'Atelier Loraine B — Association loi 1901
        </p>
        <p>
          SIRET : 924 631 450 00013 · RNA : W641014030
        </p>
      </div>
    </div>
  </footer>
);
